import { isSameDay } from 'date-fns/isSameDay'

import { DATE_FORMATS_INTL, formatDate } from '../../core/constants'
import { fromUnixUTC } from '../../core/utils/DateUtil'
import { type DataSeries, type Transaction } from '../../core'
import { formatCurrency } from '../../core/utils/NumberFormatting'

export interface ChartDataProps {
  guid?: string
  label?: string
  localized_label?: string
  amount: number
  date: string
}

export const sortByDate = (a: Transaction, b: Transaction) => {
  return b.date - a.date
}

export const shouldShowDate = (index: number, transactions: Transaction[]) => {
  if (index === 0) return true

  const currentDate = fromUnixUTC(transactions[index].date)
  const previousDate = fromUnixUTC(transactions[index - 1].date)

  return !isSameDay(currentDate, previousDate)
}

export const hasInsetBorder = (index: number, transactions: Transaction[]) => {
  if (index === transactions.length - 1) return false

  const currentDate = fromUnixUTC(transactions[index].date)
  const nextDate = fromUnixUTC(transactions[index + 1].date)

  return isSameDay(currentDate, nextDate)
}

export const buildDataSeries = (data?: DataSeries) => {
  if (!data?.data) return []

  return data.data.map((row) => {
    return Object.fromEntries((data.names || []).map((name, index) => [name, row[index]]))
  })
}

export const buildChartData = (dataSeries: ChartDataProps[], merchantName = '') => {
  const data = dataSeries.map((total) => {
    const label = formatDate(total.date, DATE_FORMATS_INTL.MONTH_SHORT)

    return {
      ariaLabel: `
        ${label},
        ${formatCurrency(total.amount, '0.00')},
        ${merchantName}`,
      label,
      value: total.amount,
      formattedAmount: formatCurrency(total.amount, '0,0'),
    }
  })

  return data
}
